import { render, staticRenderFns } from "./software.vue?vue&type=template&id=2789e48e&scoped=true&"
import script from "./software.vue?vue&type=script&lang=js&"
export * from "./software.vue?vue&type=script&lang=js&"
import style1 from "./software.vue?vue&type=style&index=1&id=2789e48e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2789e48e",
  null
  
)

export default component.exports